var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "67px",
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E9\\u05D2\\u05D9\\u05E2\\u05D4",
    transform: "translate(-404.000000, -427.000000)",
    fill: "#FF0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(275.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(129.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5,0 C14.9987062,0 0,14.9987062 0,33.5 C0,52.0012938 14.9987062,67 33.5,67 C52.0012938,67 67,52.0012938 67,33.5 C67,14.9987062 52.0014508,0 33.5,0 Z M51.9766398,43.4488874 L43.4495155,51.9766398 L33.5,42.0277524 L23.5504845,51.9772679 L15.0233602,43.4488874 L24.9722476,33.5 L15.0233602,23.5504845 L23.5504845,15.0233602 L33.5,24.9722476 L43.4495155,15.0233602 L51.9766398,23.5504845 L42.0277524,33.5 L51.9766398,43.4488874 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.207ce79fee9a8de09b9e3fcc3512383e.svg";
export { ForwardRef as ReactComponent };